import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import Projects from "./pages/Projects";
import ProjectDetails from "./pages/ProjectDetails";
import FriendsPage from "./pages/FriendsPage"; // ✅ <-- Add this line

import Dashboard from "./pages/Dashboard";
import DailyTasks from "./pages/DailyTasks";
import CalendarView from "./pages/CalendarView";
import UpcomingTasks from "./pages/UpcomingTasks";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Analytics from "./pages/Analytics";
import Leaderboard from "./pages/Leaderboard";

// PrivateRoute component for protected pages
function PrivateRoute({ children }) {
  const { user } = useContext(AuthContext);
  return user ? children : <Navigate to="/login" replace />;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Private routes */}
      <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/tasks" element={<PrivateRoute><DailyTasks /></PrivateRoute>} />
      <Route path="/calendar" element={<PrivateRoute><CalendarView /></PrivateRoute>} />
      <Route path="/upcoming" element={<PrivateRoute><UpcomingTasks /></PrivateRoute>} />
      <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
      <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
      <Route path="/projects" element={<PrivateRoute><Projects /></PrivateRoute>} />
      <Route path="/projects/:projectId" element={<PrivateRoute><ProjectDetails /></PrivateRoute>} />

      {/* ✅ Friends route */}
      <Route path="/friends" element={<PrivateRoute><FriendsPage /></PrivateRoute>} />

      {/* Analytics & Leaderboard */}
      <Route path="/analytics" element={<PrivateRoute><Analytics /></PrivateRoute>} />
      <Route path="/leaderboard" element={<PrivateRoute><Leaderboard /></PrivateRoute>} />

      {/* Catch-all: redirect unknown paths */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
